<script>
    export default {
        name: 'NormalButton',
        props: {
            //是否用于modal
            isModal: {
                type: Boolean,
                default: false,
                required: false
            },
            // 样式类型
            theme: {
                type: String,
                default: 'default',
                required: false
            },
            // 是否禁用
            disabled: {
                type: Boolean,
                default: false,
                required: false
            },
            // 下载型按钮样式
            download: {
                type: Boolean,
                default: false,
                required: false
            },
            // 按钮类型
            type:{
                type: String,
                default: 'button',
                required: false
            }
        },
        computed: {
            compClass () {
                return {
                    'normal-btn': !this.isModal,
                    'normal-modal-btn': this.isModal,
                    [`normal-btn__${this.theme}`]: this.theme,
                    'normal-btn__disabled': this.disabled,
                    'normal-btn__download': this.download
                };
            }
        }

    };
</script>
<template>
    <button :type="type" :class="compClass" :disabled="disabled">
        <slot></slot>
    </button>
</template>
<style scoped lang="less">
    @import "../../assets/less/widgets-var";

    .normal-modal-btn {
        border: none;
        display: block;
        font-size: inherit;
        flex: 1;
        color: @otherTextClr;
        text-decoration: none;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        position: relative;
        background-color: transparent;
        .px2rem(height, 88);
        .px2rem(line-height, 88);
        &:active {
            background-color: @otherDisabledBgClr;
        }

        &:after {
            content: " ";
            position: absolute;
            left: 0;
            top: 0;
            width: 1px;
            bottom: 0;
            border-left: 1px solid @otherGreyBgClr;
            color: @otherGreyBgClr;
            transform-origin: 0 0;
            transform: scaleX(0.5);
        }

        &.normal-btn__default {
            color: @otherNormalTitleClr;
        }

        &.normal-btn__primary {
            color: @primaryBg;
        }
    }

    .normal-btn {
        border: none;
        background-color: transparent;
        font-family: cmsicon;
        width: 100%;
        position: relative;
        display: block;
        margin-left: auto;
        margin-right: auto;
        .px2rem(padding-left, 28);
        .px2rem(padding-right, 28);
        .px2rem(font-size, 36);
        .px2rem(height, 88);
        .px2rem(line-height, 88);
        box-sizing: border-box;
        text-align: center;
        text-decoration: none;
        color: #FFFFFF;
        border-radius: 5px;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        overflow: hidden;
        .transition-on;

        &.normal-btn__download {
            .px2rem(border-radius, 23);
            .px2rem(height, 46);
            .px2rem(line-height, 46);
            .px2rem(font-size, 24);
        }

        &.normal-btn__default {
            background-color: #fff;
            border: 1px solid @primaryBg;
            color: @primaryBg;

            &:not(.normal-btn__disabled):active {
                border: 1px solid @primaryActiveBg;
                color: @primaryActiveBg;
            }

            &.normal-btn__disabled {
                border: none;
                background: @otherDisabledBgClr;
                color: @otherBtnBorderNoteClr;
            }
        }

        &.normal-btn__primary {
            background: @primaryBg;
            color: @whiteBg;

            &:not(.normal-btn__disabled):active {
                background: @primaryActiveBg;
                color: @whiteBg;
            }

            &.normal-btn__disabled {
                background: @primaryDisabledBg;
                color: @whiteBg;
            }
        }

        &.normal-btn__warn {
            background: @warnBg;
            color: @whiteBg;

            &:not(.normal-btn__disabled):active {
                background: @warnBg;
                color: @whiteBg;
            }

            &.normal-btn__disabled {
                background: @warnDisabledBg;
                color: @whiteBg;
            }
        }

        &.normal-btn__danger {
            background: @dangerBg;
            color: @whiteBg;

            &:not(.normal-btn__disabled):active {
                background: @dangerActiveBg;
                color: @whiteBg;
            }

            &.normal-btn__disabled {
                background: @dangerDisabledBg;
                color: @whiteBg;
            }
        }
    }
</style>
